import React from 'react';
import { Stack, Typography } from '@mui/material';
import { TextField } from 'components';
import { ResponsiveSVG } from 'components/ResponsiveSVG/ResponsiveSVG';
import { useFormContext } from 'react-hook-form';
import { useTranslationContext } from 'contexts/TranslationContext/TranslationContext';
import { useCobrand } from 'features/cobrand/hooks/useCobrandUtils';
import { cobrandImages } from 'features/cobrand/config/cobrandImages';
import { SignupFormData } from 'features/signUp/types';

export const AccessCodeSubmissionStep = () => {
  const { translation } = useTranslationContext();
  const { cobrand } = useCobrand();
  const { loginLogo } = cobrandImages[cobrand.id];
  const {
    register,
    formState: { errors },
  } = useFormContext<SignupFormData>();
  const { ref, onChange, onBlur, name, required } = register('accessCode', {
    setValueAs: (value) => value.trim(),
    required: translation('empty_field_error'),
  });

  return (
    <Stack spacing={4} id="access-code-submission__wrapper">
      <Stack pb={5}>
        <ResponsiveSVG
          deviceWidth={{ desktop: '296px', mobile: '120px' }}
          svg={loginLogo}
          containerStyle={{ maxHeight: '100px' }}
          alt={`${cobrand.displayName} logo`}
        />
      </Stack>
      <Typography variant="h5" color="primary" id="access-code-submission__header">
        {translation('access_code_header')}
      </Typography>
      <Typography variant="body1" color="grey.800" id="access-code-submission__subtitle">
        {translation('access_code_body')}
      </Typography>
      <TextField
        id="access-code-submission__access-code-input"
        label={translation('access_code')}
        name={name}
        required={required}
        onChange={onChange}
        onBlur={onBlur}
        inputRef={ref}
        error={!!errors.accessCode}
        helperText={errors.accessCode?.message}
        aria-describedby="access-code-submission__subtitle"
      />
    </Stack>
  );
};
